/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Live Session Status
 */
export type LiveSessionStatusInfo = {
    /**
     * Session Status
     */
    sessionStatus?: LiveSessionStatusInfo.sessionStatus;
    /**
     * messenger, audio, video
     */
    medium?: LiveSessionStatusInfo.medium;
    /**
     * OK to join
     */
    joinable?: boolean;
    /**
     * Meeting time Unix
     */
    meetingTime?: number;
    /**
     * Meeting time formatted for user's timezone
     */
    formattedMeetingTime?: string;
    /**
     * Secure Video Waiting Room Url
     */
    waitingRoomUrl?: string;
    /**
     * Zoom Meeting Id
     */
    zoomId?: string;
    /**
     * Zoom Connect Code
     */
    zoomConnectCode?: string;
    /**
     * Meeting Id
     */
    meetingId?: string;
    /**
     * Meeting Pin
     */
    meetingPin?: string;
    /**
     * Dial-in numbers
     */
    dialIn?: Array<string>;
    /**
     * Audio Line Open X Mins Before
     */
    audioOpenMins?: number;
    /**
     * Audio Line Closed X Mins After Meeting Time
     */
    audioClosedMins?: number;
    /**
     * Video Line Open X Mins Before Meeting Time
     */
    videoOpenMins?: number;
    /**
     * Video Line Closed X Mins After Meeting Time
     */
    videoClosedMins?: number;
    /**
     * Expert - Video Line Open X Mins Before Meeting Time
     */
    videoOpenExpertMins?: number;
    /**
     * Expert - Video Line Closed X Mins After Meeting Time
     */
    videoClosedExpertMins?: number;
}

export namespace LiveSessionStatusInfo {

    /**
     * Session Status
     */
    export enum sessionStatus {
        UNSCHEDULED = 'unscheduled',
        EARLY = 'early',
        JOINABLE = 'joinable',
        ENDED = 'ended',
        AWAIT_HOST = 'awaitHost',
    }

    /**
     * messenger, audio, video
     */
    export enum medium {
        AUDIO = 'audio',
        VIDEO = 'video',
        MESSENGER = 'messenger',
    }


}
